import { Chip } from "@mui/material";
import { KeyDriveBodyMin } from "../Fonts/Body/KeyDriveBodyMin";

interface IKeyDriveChip {
    text: string;
    backgroundColor?: string;
    color?: string;
}

export function KeyDriveChip({
    text,
    backgroundColor,
    color
}: IKeyDriveChip) {
    return (
        <Chip 
            label={
                <KeyDriveBodyMin 
                    needBold={false}
                    needEllipses={false}
                    text={text}
                    color={`${color ? color : "white"}`}
                />
            }
            sx={{
                background: `${backgroundColor ? backgroundColor : "#91B1C6"}`,
                width:"100px",
                height:"32px"
            }}
        />
    )
}